<template>
  <div id="system">
    <div class="weTech">
      <div class="qrCodeBox">
        <img src="../../assets/img/system/1.jpg" alt="" v-if="appShow" />
        <img src="../../assets/img/system/dp.png" alt="" v-else-if="wxShow" />
        <div class="closeTag" v-show="appShow || wxShow" @click="closeCode()">
          ×
        </div>
      </div>
      <el-row :gutter="80" class="elRow">
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          align="center"
          style="display: flex; align-items: center"
        >
          <div class="leftImgBox">
            <img
              src="../../assets/img/system/sys.png"
              alt=""
              v-if="bannerShow"
            />
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="itemTech">
            <h2 class="title2">系统入口</h2>
            <div class="content">
              <div class="sysItem wow animate__zoomIn" @click="goPc()">
                <img src="../../assets/img/system/pc.png" alt="" />
                <div class="sysName">公有云平台</div>
              </div>
              <div class="sysItem wow animate__zoomIn" @click="goBigscreen()">
                <img src="../../assets/img/system/dp.png" alt="" />
                <div class="sysName">公有云大屏系统</div>
              </div>
              <div class="sysItem wow animate__zoomIn" @click="goApp()">
                <img src="../../assets/img/system/app.png" alt="" />
                <div class="sysName">App掌上智慧消防</div>
              </div>
              <div class="sysItem wow animate__zoomIn" @click="goWx()">
                <img src="../../assets/img/system/wx.png" alt="" />
                <div class="sysName">微信掌上智慧消防</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <water-system /> -->
  </div>
</template>

<script>
import waterSystem from "./waterSystem";
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      appShow: false,
      wxShow: false,
      bannerShow: true,
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {
    goPc() {
      window.open("https://terata.com.cn/terata/base", "_blank");
    },
    goBigscreen() {
      window.open("https://terata.com.cn/terata/bigscreen", "_blank");
    },
    goApp() {
      this.appShow = true;
      this.bannerShow = false;
      this.wxShow = false;
    },
    goWx() {
      this.appShow = false;
      this.bannerShow = false;
      this.wxShow = true;
    },
    closeCode() {
      this.appShow = false;
      this.bannerShow = true;
      this.wxShow = false;
    },
  },
  components: {
    waterSystem,
  },
};
</script>

<style scoped lang="scss">
#system {
  .weTech {
    background: #f6f8fa;
    padding: 2% 14%;
    background-image: url("../../assets/img/system/sysbg.png");
    background-position: center;
    background-size: 100% 100%;
    position: relative;

    .qrCodeBox {
      position: absolute;
      width: 35%;
      height: 65%;
      top: 20%;
      left: 10%;
      img {
        width: 100%;
        height: 100%;
      }
      .closeTag {
        width: 2rem;
        height: 2rem;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 2rem;
        cursor: pointer;
        z-index: 999;
        color: #666666;
      }
    }
    .elRow {
      display: flex;
      flex-wrap: wrap;
      .leftImgBox {
        height: 80%;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .itemTech {
      .title2 {
        color: #333333;
        line-height: 5rem;
        font-size: 2.6rem;
        margin-bottom: 3rem;
      }
      .content {
        display: flex;
        flex-wrap: wrap;

        .sysItem {
          &:hover {
            box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
            transform: translate(0, -5px);
            transition: all 0.3s;
          }
          background: #ffffff;
          box-shadow: 0px 8px 62px 0px rgba(164, 183, 221, 0.16);
          border-radius: 10px;
          width: 20rem;
          height: 20rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 2rem 2rem 0;
          cursor: pointer;
          img {
            width: 8rem;
            height: 8rem;
            margin-bottom: 2rem;
          }
          .sysName {
            font-weight: 600;
            font-size: 1.6rem;
            color: #000000;
            line-height: 4rem;
          }
        }
      }
    }
  }
}
@import "../../assets/responsive/system.scss";
</style>
